import { render, staticRenderFns } from "./pagesider.vue?vue&type=template&id=1e477e98&scoped=true"
import script from "./pagesider.vue?vue&type=script&lang=js"
export * from "./pagesider.vue?vue&type=script&lang=js"
import style0 from "./pagesider.vue?vue&type=style&index=0&id=1e477e98&prod&lang=scss&scoped=true"
import style1 from "./pagesider.vue?vue&type=style&index=1&id=1e477e98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e477e98",
  null
  
)

export default component.exports